import styled from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system/constants/breakpoints';

// Main filters container
export const FiltersContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 8px;
	margin-top: 24px;
	margin-bottom: 24px;

	@media (max-width: 768px) {
		margin-top: 16px;
		margin-bottom: 16px;
	}
`;

// Category chips section
export const ChipsSection = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	font-size: 16px;
	flex-wrap: wrap;
`;

export const FilterChip = styled.div<{ $selected?: boolean; $disabled?: boolean }>`
	display: flex;
	align-items: center;
	background-color: ${props =>
		props.$selected ? props.theme.colors.transparent.light30 : props.theme.colors.transparent.light10};
	transition:
		background-color 0.2s ease-in-out,
		color 0.2s ease-in-out;
	border-radius: 4px;
	padding: 8px 12px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	white-space: nowrap;
	gap: 4px;
	font-size: 14px;
	line-height: 1;
	min-height: 30px;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};

	svg {
		fill: ${({ theme }) => theme.colors.icon.main};
	}

	@media (${BREAKPOINTS.MOBILE}) {
		font-size: 12px;
		padding: 4px 6px;
	}
`;

export const ChipCloseIcon = styled.div<{ $visible?: boolean }>`
	display: ${props => (props.$visible ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	cursor: pointer;
	width: 12px;
	height: 12px;
	flex-shrink: 0;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}
`;

export const ResetFilterContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	white-space: nowrap;
`;

export const ChipsDivider = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin: 0 4px;
`;

export const ResetButton = styled.div<{ $disabled?: boolean }>`
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	white-space: nowrap;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	display: flex;
	gap: 4px;
	align-items: center;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	&:hover {
		color: ${props => (props.$disabled ? props.theme.colors.text.subtitle : props.theme.colors.text.alwaysWhite)};
	}
`;

// Right actions container (sort button)
export const RightActionsContainer = styled.div`
	display: flex;
	flex-shrink: 0;
`;

// Sort dropdown
export const SortDropdown = styled.div<{ $disabled?: boolean }>`
	font-size: 16px;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.control.dark};
	border-radius: 4px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	display: flex;
	justify-content: center;
	gap: 4px;
	position: relative;
	padding: 8px;
	transition: all 0.2s linear;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	&:hover {
		background-color: ${props =>
			props.$disabled ? props.theme.colors.control.dark : props.theme.colors.control.darkHover};
	}

	@media (max-width: 768px) {
		display: none;
	}
`;

// Mobile sort icon
export const MobileSortIcon = styled.div`
	cursor: pointer;
	display: none;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 24px;
	height: 24px;
	position: relative;

	svg {
		flex-shrink: 0;
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	@media (max-width: 768px) {
		display: flex;
	}
`;

export const DropdownContent = styled.div<{ $isOpen?: boolean }>`
	background-color: ${({ theme }) => theme.colors.background.main};
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.text.body};
	left: 0;
	padding: 8px 0;
	position: absolute;
	top: 120%;
	width: 170px;
	z-index: 1;
	display: ${props => (props.$isOpen ? 'block' : 'none')};
`;

export const DropdownItem = styled.div<{ $selected?: boolean }>`
	cursor: pointer;
	margin-bottom: 3px;
	padding: 6px 16px;
	transition: all 0.2s linear;
	background-color: ${props => (props.$selected ? props.theme.colors.transparent.light10 : 'transparent')};

	&:hover {
		background-color: ${({ theme }) => theme.colors.transparent.light10};
	}
`;

export const MobileFilterTitle = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;

	svg {
		width: 24px;
		height: 24px;
		flex-shrink: 0;
	}
`;
